// Navigation of the operator area (docs/ARCHITECTURE.md, "Roles and views");
// the project area has its own in pages/project/ProjectLayout.tsx.
export interface NavItem {
  to: string
  label: string
  // administer: only super and operators (users & roles, audit log)
  administer?: boolean
  // indent: a view of the item above (Rack & network of a site)
  indent?: boolean
}

export interface NavGroup {
  label?: string
  items: NavItem[]
}

export const NAV: NavGroup[] = [
  { items: [{ to: '/ops/overview', label: 'Overview' }] },
  {
    label: 'Operate',
    items: [
      { to: '/ops/maintenance', label: 'Maintenance' },
      { to: '/ops/jobs', label: 'Jobs' },
    ],
  },
  {
    label: 'Infrastructure',
    items: [
      { to: '/ops/sites', label: 'Sites' },
      { to: '/ops/network', label: 'Network' },
      { to: '/ops/clusters', label: 'Clusters' },
      { to: '/ops/machines', label: 'Machines' },
      { to: '/ops/agents', label: 'Agents' },
      { to: '/ops/vms', label: 'Virtual machines' },
    ],
  },
  {
    label: 'Customers',
    items: [
      { to: '/ops/customers', label: 'Customers' },
      { to: '/ops/projects', label: 'Projects' },
      { to: '/ops/customer-users', label: 'Users' },
    ],
  },
  {
    label: 'Library',
    items: [
      { to: '/ops/firmware', label: 'Firmware' },
      { to: '/ops/baselines', label: 'Baselines' },
      { to: '/ops/bios-profiles', label: 'BIOS profiles' },
      { to: '/ops/hardware', label: 'Hardware' },
      { to: '/ops/images', label: 'OS images' },
      { to: '/ops/ssh-keys', label: 'SSH keys' },
    ],
  },
  {
    label: 'Services',
    items: [
      { to: '/ops/dns', label: 'DNS' },
      { to: '/ops/certificates', label: 'Certificates' },
    ],
  },
  {
    label: 'Administration',
    items: [
      { to: '/ops/users', label: 'Admins', administer: true },
      { to: '/ops/audit', label: 'Audit log', administer: true },
    ],
  },
]
